import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import BootstrapTable from 'react-bootstrap-table-next';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './Bizonylattooltips';
import BizonylatTombRaktarField from './BizonylatTombRaktarField';
import ProgressButton from '../../../commons/ProgressButton';

class BizonylattombLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalRogzit: false,
      modalNezet: false,
      modalModosit: false,
      modalTorles: false,
      modalLezaras: false,
      cegadatArray: [],
      bizonylatTipusArray: [],
      bizonylatTipusMezoInaktiv: true,
      raktarArray: [],
      raktarMezoInaktiv: true,
      bizonylatTombJson: [],
      bizonylatTombModositObj: {},
      existsRaktar: false,
      isRaktarDisabled: true,
      statuszArray: [],
      statuszOptions: [],
      filterOptions: {},
      bizonylattomb: {},
      mentesButtonLoading: false,
    };

    this.iconFormatter = this.iconFormatter.bind(this);
    this.statusFormatter = this.statusFormatter.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateTable();
      }
    }
  }

  updateTable = () => {
    Services.listBizonylattomb((err, res) => {
      if (!err) {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });

        this.setState({
          bizonylatTombJson: res[0].list,
          statuszArray: res[0].statusz,
          statuszOptions: options,
          filterOptions: filters,
          existsRaktar: res[0].existsraktar,
        });
      }
    });
  }

  setExistsRaktar = () => {
    Services.existsRaktar((err, res) => {
      if (!err) {
        this.setState({ existsRaktar: res[0].existsraktar });
      }
    });
  }

  getCegadatMezo = (cegadatId) => {
    Services.listAktivCegadat(cegadatId, (err, res) => {
      if (!err) {
        this.setState({
          cegadatArray: res[0],
          cegadatid: res[0].length === 1 ? res[0][0].id : ''
        });
      }
    });
  }

  /**
  * Lenyíló mezőhöz szükséges bizonylattípusok lekérdezése
  */
  getBizonylatTipusMezo = () => {
    Services.listAktivBizonylattipus((err, res) => {
      if (!err) {
        this.setState({
          bizonylatTipusArray: res[0],
          bizonylatTipusMezoInaktiv: false,
          bizonylattipus: res[0].length === 1 ? res[0][0].id : ''
        });
      }
    });
  }

  /**
  * Lenyíló mezőhöz szükséges raktárak lekérdezése
  */
  getRaktarMezo = (id, cegadatId, raktarMezoInaktiv) => {
    Services.listAktivRaktar(id, cegadatId, (err, res) => {
      if (!err) {
        this.setState({
          raktarArray: res[0],
          raktarMezoInaktiv: raktarMezoInaktiv,
          raktarid: !raktarMezoInaktiv && res[0].length === 1 ? res[0][0].id : ''
        });
      }
    });
  }

  /**
  * Paraméterként kapott bizonylattömb objektum felvétele adatbázisba.
  * @param {SytheticEvent} event
  * @param {object} biztombObj Bizonylattömb adatokat tartalamzó objektum.
  */
  addBizonylatTomb = (event, biztombObj) => {
    // Üres mezők null-ra alakítása
    for (let p in biztombObj) {
      if (biztombObj.hasOwnProperty(p)) {
        if (biztombObj[p] === '') {
          biztombObj[p] = null;
        }
      }
    }

    biztombObj.bizonylattipusid = biztombObj.bizonylattipus;

    this.setState({ mentesButtonLoading: true});
    Services.createBizonylattomb(biztombObj, (err) => {
      if (!err) {
        this.toggleRogzit();
        this.updateTable();
        this.props.globals.addSuccess('Bizonylattömb felvéve!');
      }
      this.setState({ mentesButtonLoading: false});
    });
  }

  /**
  * Paraméterként kapott bizonylattömb objektum módosítása adatbázisba.
  * @param {SytheticEvent} event
  * @param {object} biztombObj Bizonylattömb adatokat tartalamzó objektum.
  */
  modifyBizonylatTomb = (event, biztombObj) => {
    // Üres mezők null-ra alakítása
    for (let p in biztombObj) {
      if (biztombObj.hasOwnProperty(p)) {
        if (biztombObj[p] === '') {
          biztombObj[p] = null;
        }
      }
    }

    biztombObj.id = this.state.bizonylatTombModositObj.id;
    biztombObj.bizonylattipusid = biztombObj.bizonylattipus;

    this.setState({ mentesButtonLoading: true});
    Services.updateBizonylattomb(biztombObj, (err) => {
      if (!err) {
        this.toggleModosit();
        this.updateTable();
        this.props.globals.addSuccess('Bizonylattömb módosítva!');
      }
      this.setState({ mentesButtonLoading: false});
    });
  }

  /**
  * Paraméterben kapott bizonylattömb ID-jű rekord törlése adatbázisból
  * @param {number} id
  */
  deleteBizonylatTomb = (id) => {
    Services.deleteBizonylattomb(id, (err) => {
      if (!err) {
        this.toggleTorles();
        this.updateTable();
        this.props.globals.addSuccess('Bizonylattömb törölve!');
      }
    });
  }

  toggleNezet = () => {
    this.setState({
      modalNezet: !this.state.modalNezet
    });
  }

  toggleRogzit = () => {
    this.setState({
      modalRogzit: !this.state.modalRogzit,
    });
  }

  toggleModosit = () => {
    this.setState({
      modalModosit: !this.state.modalModosit
    });
  }

  toggleTorles = () => {
    this.setState({
      modalTorles: !this.state.modalTorles
    });
  }

  toggleLezaras = () => {
    this.setState({
      modalLezaras: !this.state.modalLezaras
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });

    return value;
  }

  handleNewClick = () => {
    this.getCegadatMezo();
    this.getBizonylatTipusMezo();
    this.setExistsRaktar();
    this.setState({
      statusz: 'AKTIV',
      bizonylatTombModositObj: {},
      raktarArray: [],
      raktarid: '',
      raktarMezoInaktiv: true
    });

    this.toggleRogzit();
  }

  /** Megtekint gombra kattintás */
  handleViewClick = (id) => {
    Services.viewBizonylattomb(id, (err, res) => {
      this._currentViewId = id;

      this.setExistsRaktar();
      this.setState({ bizonylattomb: res[0] });
      this.toggleNezet();
    });
  }

  /** Módosítás gombra kattintás */
  handleEditClick = (id) => {
    Services.getBizonylattomb(id, (err, res) => {
      if (!err) {
        this._currentEditId = id;

        let bt = res[0];
        for (let b in bt) {
          if (bt.hasOwnProperty(b)) {
            if ((Number(bt[b]) === bt[b] && bt[b] % 1 === 0) || typeof (bt[b]) === 'boolean') {
              bt[b] = bt[b].toString();
            }
          }
        }
        bt.statusz = bt.statusz.name;

        this.setState({
          bizonylatTombModositObj: bt
        });
        
        this.getCegadatMezo(bt.cegadatid);
        this.getBizonylatTipusMezo();
        this.setExistsRaktar();
        if (this.state.existsRaktar) {
          this.getRaktarMezo(bt.raktarid, bt.cegadatid, this.state.raktarMezoInaktiv);
        }

        this.toggleModosit();
      }
    });
  }

  /** Törlés gombra kattintás */
  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  /** Lezárás gombra kattintás */
  handleLezarasClick = (id) => {
    this._currentDeleteId = id;
    this.toggleLezaras();
  }

  lockBizonylattomb = (id) => {
    Services.lockBizonylattomb(id, (err) => {
      if (!err) {
        this.toggleLezaras();
        this.updateTable();
        this.props.globals.addSuccess('Bizonylattömb lezárva!');
      }
    });
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleViewClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>
          Megtekintés
        </UncontrolledTooltip>
        {
            this.props.globals.hasRole(['BIZONYLAT_TOMB'], true) && (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>
                  Módosítás
                </UncontrolledTooltip>
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>
                  Törlés
                </UncontrolledTooltip>
                {/* {row.statusz === '{"name":"AKTIV","caption":"Aktív"}' && ( */}
                {row.statusz === 'AKTIV' && (
                <React.Fragment>
                  <Button className="table-action-icon" id={'action-view-' + cell + 'lezaras'} onClick={() => this.handleLezarasClick(cell)}>
                    <i className="fa fa-lock" />
                  </Button>
                  <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'lezaras'} delay={0}>
                    Lezárás
                  </UncontrolledTooltip>
                </React.Fragment>
                )}
              </React.Fragment>
          )}
      </div>
    );
  }

  /**
  * Visszaadja a Bizonylattömbhöz tartozó státus jelvényeket.
  * @param {boolean} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
  */
  statusFormatter = (cell) => {
    let statusz = this.state.statuszArray.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  /**
  * Visszaadja a bizonylatTombJson paramtérben kapott id-jű elemének az adatait.
  * @param {number} id - Kiválaszott bizonylattomb id-ja.
  * @return {Array.ReactElement} bizonylattomb részletes információ.
  */
  renderReszletes = () => {

    return (
      <div>
        <h6>Bizonylattömb információ:</h6>
        <b>Cégadat: </b> {this.state.bizonylattomb && this.state.bizonylattomb.cegadatnev}<br />
        <b>Bizonylattípus neve: </b> {this.state.bizonylattomb && this.state.bizonylattomb.biztipusnev}<br />
        <b>Bizonylattömb neve: </b> {this.state.bizonylattomb && this.state.bizonylattomb.nev}<br />
        <b>Szigorú számadású? </b> {this.state.bizonylattomb && this.state.bizonylattomb.szigoruszamadas && this.state.bizonylattomb.szigoruszamadas.toString() == 'true' ? 'Igen' : 'Nem'}<br />
        <b>Kézi bizonylat? </b> {this.state.bizonylattomb && this.state.bizonylattomb.kezi && this.state.bizonylattomb.kezi.toString() == 'true' ? 'Igen' : 'Nem'}<br />
        <b>Előtag: </b> {this.state.bizonylattomb && this.state.bizonylattomb.elotag}<br />
        <b>Utótag: </b> {this.state.bizonylattomb && this.state.bizonylattomb.utotag}<br />
        <b>Kezdő sorszám: </b> {this.state.bizonylattomb && this.state.bizonylattomb.kezdosorsz}<br />
        <b>Utolsó szorszám: </b> {this.state.bizonylattomb && this.state.bizonylattomb.utolsosorsz}<br />
        {this.state.existsRaktar && (
          <React.Fragment>
            <b>Raktár: </b>
              {this.state.bizonylattomb && this.state.bizonylattomb.raktarnev}
            <br />
          </React.Fragment>
        )}
        <b>Példányszám: </b> {this.state.bizonylattomb && this.state.bizonylattomb.peldanyszam}<br />
        <b>Státusz: </b> {this.state.bizonylattomb && this.state.bizonylattomb.statusz}<br />
      </div>
    );
  }

  renderBizonylatTipusOptions = () => {
    return this.state.bizonylatTipusArray.map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
  }

  renderCegadatOptions = () => {
    return this.state.cegadatArray.map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.tipus + ')'}</option>);
  }

  renderRaktarOptions = () => {
    return this.state.raktarArray.map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
  }

  render() {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [{
        text: '5', value: 5
      }, {
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }],
    };

    const columns = [
      {
        dataField: 'cegadatnev',
        text: 'Cégadat',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: {
          width: 150
        },
        sort: true
      },
      {
        dataField: 'tipusnev',
        text: 'Biz. típus név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: {
          width: 150
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Biz. tömb név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'elotag',
        text: 'Előtag',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: {
          width: 110
        },
        sort: true
      },
      {
        dataField: 'utotag',
        text: 'Utótag',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: {
          width: 110
        },
        sort: true
      },
      {
        dataField: 'raktarnev',
        text: 'Raktár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        hidden: !this.state.existsRaktar
      },
      {
        dataField: 'statusz',
        text: 'Státusz',
        formatter: this.statusFormatter,
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        style: {
          width: 120
        },
        align: 'center',
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: (cell, row) => this.iconFormatter(cell, row),
        style: {
          width: 120
        },
      },
    ];

    const modifyObj = this.state.bizonylatTombModositObj;

    return (
      <div>
        {
          this.props.globals.hasRole(['BIZONYLAT_TOMB']) &&
          <div className="row">
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>Új bizonylattömb</Button>
            </div>
          </div>
        }

        <BootstrapTable
          bootstrap4
          keyField="id"
          columns={columns}
          data={this.state.bizonylatTombJson}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
        />

        <Modal isOpen={this.state.modalRogzit} toggle={this.toggleRogzit} className={this.props.className} backdrop="static" size="lg">
          <RFForm
            modal
            onSubmit={this.addBizonylatTomb}
            title={"Bizonylattömb felvétel"}
            footer={
              <React.Fragment>
                <ProgressButton color="primary" loading={this.state.mentesButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleRogzit}>Mégsem</Button>
              </React.Fragment>
            }
          >
            <Row>
              <Col lg={6}>
                <RFField
                  type="select"
                  name="cegadatid"
                  id="cegadatid"
                  label="Cégadat: *"
                  required
                  onChange={v => {
                    let value = this.handleInputChange(v);
                    if (value && this.state.existsRaktar) {
                      this.getRaktarMezo(null, value, this.state.raktarMezoInaktiv);
                    }
                  }}
                  defaultSelect={<option value="">Válassz cégadatot...</option>}
                  selectOptions={this.renderCegadatOptions()}
                  value={this.state.cegadatid}
                />
              </Col>
              <Col lg={6}>
                <RFField
                  type="select"
                  name="statusz"
                  id="statusz"
                  label="Státusz"
                  required
                  defaultSelect={[]}
                  onChange={this.handleInputChange}
                  value={this.state.statusz}
                  selectOptions={this.state.statuszOptions}
                  disabled={!this.state.cegadatid}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <RFField
                  type="select"
                  name="bizonylattipus"
                  id="bizonylattipus"
                  label="Bizonylattípus:"
                  value={this.state.bizonylattipus}
                  onChange={(e) => {
                    let kapcs = this.state.bizonylatTipusArray && this.state.bizonylatTipusArray.filter(x => x.id === parseInt(e.target.value, 10))[0].raktarhozkapcs;
                    let raktarid;
                    if (!kapcs) {
                      raktarid = ''
                    } else {
                      raktarid = this.state.raktarArray.length === 1 ? this.state.raktarArray[0].id : this.state.raktarid
                    }
                    this.setState({ raktarMezoInaktiv: !kapcs, raktarid: raktarid });
                  }}
                  required
                  defaultSelect={<option value="" disabled>Válassz bizonylattípust...</option>}
                  selectOptions={this.renderBizonylatTipusOptions()}
                  disabled={this.state.bizonylatTipusMezoInaktiv || !this.state.cegadatid}
                />
              </Col>
              <Col lg={6}>
                <RFField
                  type="text"
                  label="Bizonylattömb neve"
                  name="nev"
                  id="nev"
                  maxLength="50"
                  required
                  disabled={!this.state.cegadatid}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <RFField
                  type="select"
                  name="szigoruszamadas"
                  id="SzigoruFelvitel"
                  label="Szigorú számadású?"
                  tooltip={<CustomTooltip text={getTooltip('szigoruszamadas')} id="szigoruszamadasTT" />}
                  value="false"
                  onChange={e => this.setState({ szigoruszamadas: e.target.value })}
                  required
                  defaultSelect={
                    <React.Fragment>
                      <option value="false">Nem</option>
                      <option value="true">Igen</option>
                    </React.Fragment>
                  }
                  selectOptions={[]}
                  disabled={!this.state.cegadatid}
                />
              </Col>
              <Col lg={6}>
                <RFField
                  type="select"
                  name="kezi"
                  id="kezi"
                  label="Kézi bizonylat?"
                  value="false"
                  onChange={e => this.setState({ kezi: e.target.value })}
                  defaultSelect={
                    <React.Fragment>
                      <option value="false">Nem</option>
                      <option value="true">Igen</option>
                    </React.Fragment>
                  }
                  selectOptions={[]}
                  disabled={!this.state.cegadatid}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <RFField
                  type="text"
                  label="Előtag/Tömbjel"
                  tooltip={<CustomTooltip text={getTooltip('elotag')} id="elotagTT" />}
                  name="elotag"
                  id="ElotagFelvitel"
                  maxLength="17"
                  required
                  disabled={!this.state.cegadatid}
                />
              </Col>

              <Col lg={6}>
                <RFField
                  type="text"
                  label="Utótag/Évszám"
                  name="utotag"
                  id="utotag"
                  maxLength="6"
                  required
                  disabled={!this.state.cegadatid}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <RFField
                  label="Kezdő sorszám"
                  name="kezdosorsz"
                  id="kezdosorsz"
                  maxLength="10"
                  required
                  disabled={!this.state.cegadatid}
                  numberOnlyWhole

                />
              </Col>
              <Col lg={6}>
                <RFField
                  label="Utolsó sorszám"
                  name="utolsosorsz"
                  id="utolsosorsz"
                  maxLength="10"
                  required
                  disabled={!this.state.cegadatid}
                  numberOnlyWhole
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <RFField
                  label="Példányszám"
                  name="peldanyszam"
                  id="peldanyszam"
                  maxLength="3"
                  required
                  disabled={!this.state.cegadatid}
                  numberOnlyWhole
                />
              </Col>
              {this.state.existsRaktar && (
                <Col lg={6}>
                  <BizonylatTombRaktarField
                    cegadatid={this.state.cegadatid}
                    inaktiv={this.state.raktarMezoInaktiv}
                    onChange={this.handleInputChange}
                    options={this.renderRaktarOptions()}
                    raktarid={this.state.raktarid}
                  />
                </Col>
              )}
            </Row>
          </RFForm>
        </Modal>

        <Modal isOpen={this.state.modalModosit} toggle={this.toggleModosit} className={this.props.className} backdrop="static" size="lg">
          <RFForm
            modal
            onSubmit={this.modifyBizonylatTomb}
            title={"Bizonylattömb módosítás"}
            footer={
              <React.Fragment>
                <ProgressButton color="primary" loading={this.state.mentesButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleModosit}>Mégsem</Button>
              </React.Fragment>
            }
          >
          <Row>
            <Col lg={6}>
              <RFField
                type="select"
                name="cegadatid"
                id="cegadatid"
                label="Cégadat: *"
                required
                onChange={v => {
                  let value = this.handleInputChange(v);
                  if (value && this.state.existsRaktar) {
                    this.getRaktarMezo(null, value, this.state.raktarMezoInaktiv);
                  } else {
                    modifyObj.raktarid = '';
                  }
                  modifyObj.cegadatid = value;
                  
                  this.setState({ bizonylatTombModositObj: modifyObj });
                }}
                defaultSelect={<option value="">Válassz cégadatot...</option>}
                selectOptions={this.renderCegadatOptions()}
                value={modifyObj.cegadatid}
              />
            </Col>
            <Col lg={6}>
              <RFField
                type="select"
                name="statusz"
                id="statusz"
                value={modifyObj.statusz}
                label="Státusz *"
                required
                defaultSelect={[]}
                selectOptions={this.state.statuszOptions}
                disabled={modifyObj && !modifyObj.cegadatid}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RFField
                type="select"
                name="bizonylattipus"
                id="bizonylattipus"
                label="Bizonylattípus:"
                value={modifyObj && modifyObj.bizonylattipusid}
                disabled={this.state.bizonylatTipusMezoInaktiv || (modifyObj && !modifyObj.cegadatid)}
                onChange={(e) => {
                  let kapcs = this.state.bizonylatTipusArray && this.state.bizonylatTipusArray.filter(x => x.id === parseInt(e.target.value, 10))[0].raktarhozkapcs;
                  let value = '';
                  if (kapcs) {
                    value = this.state.raktarArray.length === 1 ? this.state.raktarArray[0].id : modifyObj.raktarid;
                  }
                  modifyObj.raktarid = value;
                  this.setState({ raktarMezoInaktiv: !kapcs });
                }}
                required
                defaultSelect={<option value="" disabled>Válassz bizonylattípust...</option>}
                selectOptions={this.renderBizonylatTipusOptions()}
              />
            </Col>
            <Col lg={6}>
              <RFField
                type="text"
                label="Bizonylattömb neve"
                name="nev"
                id="nev"
                value={modifyObj.nev}
                maxLength="50"
                required
                disabled={modifyObj && !modifyObj.cegadatid}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RFField
                type="select"
                name="szigoruszamadas"
                id="SzigoruModosit"
                label="Szigorú számadású?"
                tooltip={<CustomTooltip text={getTooltip('szigoruszamadas')} id="szigoruszamadasTT" />}
                value={modifyObj.szigoruszamadas}
                onChange={e => this.setState({ szigoruszamadas: e.target.value })}
                required
                defaultSelect={
                  <React.Fragment>
                    <option value="false">Nem</option>
                    <option value="true">Igen</option>
                  </React.Fragment>
                }
                selectOptions={[]}
                disabled={modifyObj && !modifyObj.cegadatid}
              />
            </Col>
            <Col lg={6}>
              <RFField
                type="select"
                name="kezi"
                id="kezi"
                label="Kézi bizonylat?"
                value={modifyObj.kezi}
                onChange={e => this.setState({ kezi: e.target.value })}
                defaultSelect={
                  <React.Fragment>
                    <option value="false">Nem</option>
                    <option value="true">Igen</option>
                  </React.Fragment>
                }
                selectOptions={[]}
                disabled={modifyObj && !modifyObj.cegadatid}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RFField
                type="text"
                label="Előtag/Tömbjel"
                tooltip={<CustomTooltip text={getTooltip('elotag')} id="elotagTT" />}
                name="elotag"
                value={modifyObj.elotag}
                id="ElotagModositas"
                maxLength="17"
                required
                disabled={modifyObj && !modifyObj.cegadatid}
              />
            </Col>
            <Col lg={6}>
              <RFField
                type="text"
                label="Utótag/Évszám"
                name="utotag"
                id="utotag"
                value={modifyObj.utotag}
                maxLength="6"
                required
                disabled={modifyObj && !modifyObj.cegadatid}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RFField
                label="Kezdő sorszám"
                name="kezdosorsz"
                id="kezdosorsz"
                value={modifyObj.kezdosorsz}
                maxLength="10"
                required
                disabled={modifyObj && !modifyObj.cegadatid}
                numberOnlyWhole
              />
            </Col>
            <Col lg={6}>
              <RFField
                label="Utolsó sorszám"
                name="utolsosorsz"
                id="utolsosorsz"
                value={modifyObj.utolsosorsz}
                maxLength="10"
                required
                disabled={modifyObj && !modifyObj.cegadatid}
                numberOnlyWhole
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RFField
                label="Példányszám"
                name="peldanyszam"
                id="peldanyszam"
                value={modifyObj.peldanyszam}
                maxLength="3"
                required
                disabled={modifyObj && !modifyObj.cegadatid}
                numberOnlyWhole
              />
            </Col>
            {this.state.existsRaktar && ( 
              <Col lg={6}>
                <BizonylatTombRaktarField
                  cegadatid={modifyObj.cegadatid}
                  inaktiv={this.state.raktarMezoInaktiv}
                  onChange={v => {
                    let value = this.handleInputChange(v);

                    modifyObj.raktarid = value;
                    this.setState({ bizonylatTombModositObj: modifyObj});
                  }}
                  options={this.renderRaktarOptions()}
                  // raktarid={this.state.raktarid}
                  raktarid={modifyObj.raktarid}
                />
              </Col>
            )}
          </Row>
        </RFForm>
      </Modal>

      <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className}>
        <ModalHeader toggle={this.toggleTorles}>Törlés</ModalHeader>
        <ModalBody>
          Valóban törölni kívánod a kiválasztott tételt?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => this.deleteBizonylatTomb(this._currentDeleteId)}>OK</Button>
          <Button type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={this.state.modalLezaras} toggle={this.toggleLezaras} className={this.props.className}>
        <ModalHeader toggle={this.toggleLezaras}>Lezárás</ModalHeader>
        <ModalBody>
          Valóban kívánod lezárni a kiválasztott tételt?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => this.lockBizonylattomb(this._currentDeleteId)}>OK</Button>
          <Button type="button" color="secondary" onClick={this.toggleLezaras}>Mégsem</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
        <ModalHeader>Megtekintés</ModalHeader>
        <ModalBody>
          {this.state.modalNezet ? this.renderReszletes(this._currentViewId) : <div />}
        </ModalBody>
        <ModalFooter>
          <Button className="btn-cursor-pointer" type="button" color="primary" onClick={this.toggleNezet}>Vissza</Button>
        </ModalFooter>
      </Modal>
      </div>
    );
  }
}

BizonylattombLista.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool,
  className: PropTypes.string,
};

export default BizonylattombLista;
